import { TOptions } from "i18next"
import { useTranslation } from "react-i18next"
import { VariableCompensationTypeEnum } from "@oysterhr/schema"

type TranslationContext = "StaffForm" | "NewHireForm" | "Common"

interface UseVariableCompensationTranslationsProps {
  compensationType: VariableCompensationTypeEnum | "GENERIC"
  fileContext: TranslationContext
}

export const useVariableCompensationTranslations = ({
  compensationType = "GENERIC",
  fileContext,
}: UseVariableCompensationTranslationsProps) => {
  const [t] = useTranslation(`variable_compensation/${fileContext}`)

  const getTranslation = (
    key: string,
    otherFileContext?: TranslationContext,
    options?: TOptions,
  ) => {
    const translationKey = `${compensationType}.${key}`
    const ns = `variable_compensation/${otherFileContext || fileContext}`
    return t(translationKey, {
      ns,
      ...options,
    })
  }

  return getTranslation
}
